/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ChangeRequestNew({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#ChangeRequestNew_svg__a)"><path d="M12.5 8.88a.72.72 0 0 1 .72.72v1.68h1.68a.72.72 0 0 1 0 1.44h-1.68v1.68a.72.72 0 1 1-1.44 0v-1.68H10.1a.72.72 0 0 1 0-1.44h1.68V9.6a.72.72 0 0 1 .72-.72" /><path fillRule="evenodd" d="M13.1 6.03a2.601 2.601 0 1 0-1.2 0v.47c0 .33-.023.686-.07 1.046a2.16 2.16 0 0 1 1.194-.042q.076-.492.076-1.004zm-4.966 6.866A6.6 6.6 0 0 1 6.5 13.1h-.47A2.601 2.601 0 1 1 2.9 9.97V1.5a.6.6 0 0 1 1.2 0v8.47a2.6 2.6 0 0 1 1.93 1.93h.47c.506 0 .996-.07 1.46-.2a2.2 2.2 0 0 0 .174 1.196m4.518-4a.72.72 0 0 0-.872.704v.86a6.6 6.6 0 0 0 .872-1.564M11.05 11.28c-.461.44-.986.813-1.56 1.105a.72.72 0 0 1 .609-1.105zM11.1 3.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0m-9 9a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0" clipRule="evenodd" /></g><defs><clipPath id="ChangeRequestNew_svg__a"><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;